import CreateShiftRequest from '@/models/Shifts/CreateShiftRequest';

export default class CreateBookingRoleRequest {
    ownerId: string;
    contactId: string;
    positionId: string;
    positionDescription: string;
    chargeRate = 0;
    deskId: string;
    uniformId: string;
    uniformDescription: string;
    skillIds: string[] = [];
    qualificationIds: string[] = [];
    shifts: CreateShiftRequest[] = [];
}